<div class="row" *ngIf="form" [formGroup]="form">
    <div class="col-md-4" style="padding: 15px">
        <mat-label class="mat-label-general">Add To Matrix</mat-label>
    </div>
    <div class="col-md-8">
        <mat-select
            class="dropdown-wrapper"
            panelClass="dropdown-wrapper"
            name="matrix_new"
            [class.spinner]="loading"
            formControlName="matrix"
            matTooltip="Select a Matrix"
            [matTooltipDisabled]="form.get('matrix').valid"
        >
            <mat-option class="option-list" *ngFor="let matrix of matrixList" [value]="matrix.userMatrixId">{{ matrix.name }}</mat-option>
            <mat-option class="option-list" value="New">New..</mat-option>
        </mat-select>
        <ng-container *ngIf="form.get('matrix').value == 'New'">
            <mat-form-field class="example-full-width custom-text-field" [floatLabel]="'never'">
                <input
                    matInput
                    type="text"
                    formControlName="matrixNewName"
                    name="matrix_New_Name"
                    matTooltip="Enter a valid Name for Matrix"
                    [matTooltipDisabled]="form.get('matrixNewName').valid"
                />
            </mat-form-field>
        </ng-container>
    </div>
</div>
